import React, { Component } from 'react';
import { ItemOptionsFilter } from './ItemOptionsFilter';
import { POItemInfo } from './POItemInfo';

export class POSummary extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        console.log("PROPS", this.props);
        var POInfo = this.props.POInfo;
        var items = this.props.filterItems(POInfo.items);
        var updateRecievedQtyFunction = this.props.updateRecievedQty;
        var handleMissingItemsFunction = this.props.handleMissingItems;
        var handleWrongItemsFunction = this.props.handleWrongItems;
        var handleWrongBackingFunction = this.props.handleWrongBacking;
        return (
            <div>
                <div className="receiving-session-info">
                    <div className="receipt-po-num"><h1>PO Number: {POInfo.poNumber}</h1></div>
                    <div className="receipt-tote-id"><h1>Tote ID: {this.props.toteId}</h1></div>
                </div>
                <div className="po-summary-buttons">
                    <button className="po-summary-receive-cancel" onClick={this.props.cancelSession}>Cancel</button>
                    <button className="po-summary-receive-submit" onClick={this.props.submitPurchaseOrder}>Submit Session</button>
                </div>
                <ItemOptionsFilter
                    updateFilterObject={this.props.updateFilterObject}
                    resetFilters={this.props.resetFilters}
                    showHideCompletes={this.props.showHideCompletes}
                    itemFilters={this.props.itemFilters}
                    hideCompletes={this.props.hideCompletes}
                />
                {
                    //Loop through the line items and display them
                    items.map(function (item, idx) {
                        return (
                            <POItemInfo
                                itemInfo={item}
                                updateRecievedQty={updateRecievedQtyFunction}
                                handleMissingItems={handleMissingItemsFunction}
                                handleWrongItems={handleWrongItemsFunction}
                                handleWrongBacking={handleWrongBackingFunction}
                            />
                        );
                    })
                }
            </div>
        );
    }
}